import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import * as React from "react";
import defaultRenderEmpty from "./renderEmpty";
import { jsx as _jsx } from "react/jsx-runtime";
var defaultGetPrefixCls = function defaultGetPrefixCls(suffixCls, customizePrefixCls) {
  if (customizePrefixCls) return customizePrefixCls;
  return suffixCls ? "pi-".concat(suffixCls) : "pi";
};
export var ConfigContext = /*#__PURE__*/React.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: defaultGetPrefixCls,
  renderEmpty: defaultRenderEmpty
});
export var ConfigConsumer = ConfigContext.Consumer;

// =========================== withConfigConsumer ===========================
// We need define many types here. So let's put in the block region

/** @deprecated Use hooks instead. This is a legacy function */
export function withConfigConsumer(config) {
  return function withConfigConsumerFunc(Component) {
    // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
    var SFC = function SFC(props) {
      return /*#__PURE__*/_jsx(ConfigConsumer, {
        children: function children(configProps) {
          var basicPrefixCls = config.prefixCls;
          var getPrefixCls = configProps.getPrefixCls;
          var customizePrefixCls = props.prefixCls;
          var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
          return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread(_objectSpread({}, configProps), props), {}, {
            prefixCls: prefixCls
          }));
        }
      });
    };
    var cons = Component.constructor;
    var name = cons && cons.displayName || Component.name || "Component";
    SFC.displayName = "withConfigConsumer(".concat(name, ")");
    return SFC;
  };
}